export default __webpack_public_path__ + "static/logo-6b7f03c3a6d1c811bbd7b7a5fd9d9b4a.png";